import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import UserAvatarWithName from '../../../components/UserAvatar/UserAvatarWithName';
import SelectUserComboBox from '../../../components/SelectUserComboBox';
import dataModel from '../../../models/DataModel';
import DataSource from '../../../dao/DataSource/DataSource';
import * as BuildOwnerPermissionsUtil from '../../../helpers/permissions/BuildOwnerPermissionsUtil';
import moment from 'moment';
import './BuildOwnerTaskEdit.scss';

const taskDescriptor = {
  task: {
    completion_criteria: {
      attachments: {
        additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'],
        conversions: {},
        user: {}, 
      } ,
      comments: { user: { additionalFields: ['profile_image'] } },
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {},
    },
    reference_documents: {},
    user_task_assignments: {
      user: { additionalFields: ['profile_image'], 
        companies: {},
      },
    },
    build_owners: { companies: {} },
    inventory_items: {  inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
  },
};

export class BuildOwnerTaskEdit extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { 
      menu: null, 
      completionSteps: true,
    };
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.props.task) {
      this.taskDataSource = new DataSource('Task', this.props.task.id, taskDescriptor, this.handleTaskUpdate);
      this.taskDataSource.get();
    }
  }

  handleTaskUpdate(task, action, acData) {
    if (task) {
      if (acData && this.state.amEditinTask) {
        task.name = this.state.task.user_task_assignments;
        this.props.editCallBack(task);
      }
      this.setState({ task });
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }

  createMemberArrayWithName(userList, type) {
    if (userList) {
      return userList.map(user => {
        return <UserAvatarWithName id={'user-avatar-with-name' + type + user.id} key={'user-avatar-with-name' + user.id} user={user} />;
      });
    }
    else {
      return null;
    }
  }

  handleGetAssignedUsers(task, assignmentType){
    let field_users = task.user_task_assignments.filter(user_task_assignment => {
      if (
        !user_task_assignment.toBeDeleted && user_task_assignment.user
        && user_task_assignment.assignment_type == assignmentType
        ) {
        return true;
      }
      else return false;
    });
    return field_users;
  }

  // TODO: combine the next 2 functions
  makeFieldUserAssigment(selectedOption) {
    let editedTask = this.state.task;

    let userTaskAssignments = editedTask.user_task_assignments.filter(uta => {
      return (uta.user_id == selectedOption.user.id || (uta.user && uta.user.id == selectedOption.user.id)) && uta.assignment_type == 'field_user';
    });
    if (selectedOption.selected) {
      if (userTaskAssignments.length == 0) {
        editedTask.user_task_assignments.push({ assignment_type: 'field_user', user: selectedOption.user, toBeAdded: true });
      }
      else if (userTaskAssignments[0].toBeDeleted) {
        delete userTaskAssignments[0].toBeDeleted;
      }
    }
    else if (userTaskAssignments.length > 0) {
      if (userTaskAssignments[0].id) {
        userTaskAssignments[0].toBeDeleted = true;
      }
      else {
        const index = editedTask.user_task_assignments.indexOf(userTaskAssignments[0]);
        if (index >= 0) {
          editedTask.user_task_assignments.splice(index, 1);
        }
      }
    }
    this.setState({ task: editedTask, amEditinTask: true });
    this.props.editCallBack(editedTask);
    dataModel.dataChanged = true;
  }

  makeReviewerAssigment(selectedOption) {
    let editedTask = this.state.task;

    let userTaskAssignments = editedTask.user_task_assignments.filter(uta => {
      return (uta.user_id == selectedOption.user.id || (uta.user && uta.user.id == selectedOption.user.id)) && uta.assignment_type == 'reviewer';
    });
    if (selectedOption.selected) {
      if (userTaskAssignments.length == 0) {
        const currentUser_task = editedTask.user_task_assignments.filter(uta => {
          return uta.assignment_type == 'reviewer';
        });
        if (currentUser_task.length > 0) {
          if (!currentUser_task[0].id) {
            const index = editedTask.user_task_assignments.indexOf(currentUser_task[0]);
            if (index >= 0) {
              editedTask.user_task_assignments.splice(index, 1);
            }
          }
          else {
            currentUser_task[0].toBeDeleted = true;
          }
        }
        editedTask.user_task_assignments.push({ assignment_type: 'reviewer', user: selectedOption.user, toBeAdded: true });
      }
      else if (userTaskAssignments[0].toBeDeleted) {
        delete userTaskAssignments[0].toBeDeleted;
      }
    }
    else {
      if (userTaskAssignments.length > 0) {
        if (userTaskAssignments[0].id) {
          userTaskAssignments[0].toBeDeleted = true;
        }
        else {
          const index = editedTask.user_task_assignments.indexOf(userTaskAssignments[0]);
          if (index >= 0) {
            editedTask.user_task_assignments.splice(index, 1);
          }
        }
      }
    }
    this.setState({ task: editedTask, amEditinTask: true });
    this.props.editCallBack(editedTask);
    dataModel.dataChanged = true;
  }

  handleFieldUserSelection(type, selectedOption) {
    this.makeFieldUserAssigment(selectedOption);
  }

  handleReviewerSelection(type, selectedOption) {
    this.makeReviewerAssigment(selectedOption);
  }

  get isBuildOwner() {
    return BuildOwnerPermissionsUtil.isBuildOwnerOfBuild(this.props.build, this.props.currentUser.id);
  }

  doesNotBelongToParentCompany(user) {
    if ((user.primary_company && user.primary_company.id == this.props.currentUser.companies[0].id)
        || (user.primary_company_id && user.primary_company_id == this.props.currentUser.companies[0].id)
        || (user.companies && user.companies.length > 0 && user.companies[0].id != this.props.project.company_id)) {
      return true;
    }
    return false;
  }

  render() {
    const { project } = this.props;

    const { task } = this.state;

    if (!task) {
      return null;
    }

    const field_user = this.handleGetAssignedUsers(task, 'field_user');
    const reviewer_users = this.handleGetAssignedUsers(task, 'reviewer');

    const stepsRejected = task.completion_criteria ? task.completion_criteria.filter(cc => {
      return cc.rejected_at && !cc.approved_at && !cc.reviewed_at && !cc.completed_at;
    }) :[];

    let taskStatus = this.textMap.notStarted;
    if (stepsRejected.length > 0) {
      taskStatus = this.textMap.rejected;
    }
    else if (task.status == 'completed') {
      taskStatus = this.textMap.completed;
    }
    else if (task.status == 'pending_approval') {
      taskStatus = this.textMap.awaitingApproval;
    }
    else if (task.status == 'pending_review') {
      taskStatus = this.textMap.awaitingReview;
    }
    else if (task.status == 'not_started') {
      taskStatus = this.textMap.notStarted;
    }
    else {
      taskStatus = this.textMap.inProgress;
    }

    const assignedToUsers = task.user_task_assignments ? task.user_task_assignments.filter(user_task_assignment => {
      if (user_task_assignment.toBeDeleted) {
        return false;
      }
      if (user_task_assignment.user && user_task_assignment.assignment_type == 'field_user') {
        return true;
      }
      else {
        return false;
      }
    }).map(ut => {
      return ut.user;
    }) : [];

    const reviewerUsers = reviewer_users.filter(user_task_assignment => {
      if (user_task_assignment.user && user_task_assignment.assignment_type == 'reviewer' && !user_task_assignment.toBeDeleted) {
        return true;
      }
      else {
        return false;
      }
    }).map(ut => {
      return ut.user;
    });

    const approverUsers = task.user_task_assignments ? task.user_task_assignments.filter(user_task_assignment => {
      if (user_task_assignment.toBeDeleted) {
        return false;
      }
      if (user_task_assignment.user && user_task_assignment.assignment_type == 'approver') {
        return true;
      }
      else {
        return false;
      }
    }).map(ut => {
      return ut.user;
    }) : [];

    const notifiedUsers = task.user_task_assignments ? task.user_task_assignments.filter(user_task_assignment => {
      if (user_task_assignment.toBeDeleted) {
        return false;
      }
      if (user_task_assignment.user && user_task_assignment.assignment_type == 'notify') {
        return true;
      }
      else {
        return false;
      }
    }).map(ut => {
      return ut.user;
    }) : [];

    let assignedToAvatars = <div className='value'>{this.textMap.noneAssigned}</div>;
    if (this.state.amEditinTask && field_user.length > 0) {
      const assignedImages = this.createMemberArrayWithName(field_user.map(user => user.user), 'field_user');
      assignedToAvatars = <div className="member-display-stacked">
        <div className="member-array-stacked">
          {assignedImages}
        </div>
      </div>;
    } else if (assignedToUsers.length > 0) {
      const assignedImages = this.createMemberArrayWithName(assignedToUsers, 'field_user');
      assignedToAvatars = <div className="member-display-stacked">
        <div className="member-array-stacked">
          {assignedImages}
        </div>
      </div>;
    }

    let reviewerAvatars = this.isBuildOwner ? null : <div className='value'>{this.textMap.noneAssigned}</div>;
    if (reviewerUsers.length > 0) {
      const reviewerImages = this.createMemberArrayWithName(reviewerUsers, 'reviewer');
      reviewerAvatars = <div className="member-display-stacked">
        <div className="member-array-stacked">
          {reviewerImages}
        </div>
      </div>;
    }

    let approverAvatars = <div className='value'>{this.textMap.noneAssigned}</div>;
    if (approverUsers.length > 0) {
      const approverImages = this.createMemberArrayWithName(approverUsers, 'approver');
      approverAvatars = <div className="member-display-stacked">
        <div className="member-array-stacked">
          {approverImages}
        </div>
      </div>;
    }

    let notifiedAvatars = <div className='value'>{this.textMap.noneAssigned}</div>;
    if (notifiedUsers.length > 0) {
      const notifiedImages = this.createMemberArrayWithName(notifiedUsers, 'notify');
      notifiedAvatars = <div className="member-display-stacked">
        <div className="member-array-stacked">
          {notifiedImages}
        </div>
      </div>;
    }

    let dueDate = null;
    let dueTime = null;
    if (task.due_date) {
      const date = moment(new Date(task.due_date));
      dueDate = date.format('MM/DD/YYYY');
      dueTime = date.format('h:mm a');
    }

    let assignedToSection = <div className="info-detail">
      <div className="caption">{assignedToAvatars && assignedToAvatars.length > 1 ? 'Assigned To' : this.textMap.assignedTo}</div>
      {assignedToAvatars}
    </div>;

    let reviewerSection = <div className="info-detail">
      <div className="caption">{this.textMap.reviewer}</div>
      {reviewerAvatars}
    </div>;

    let isParentFieldUser = false;
    if (this.isBuildOwner) {
      let field_userFilter = [];
      let reviewerFilter = [];
      let approverFilter = [];
      let notifyFilter = [];

      const buildOwnersUsers = [];
      const nonBuildOwnerUsers = [];

      field_user.forEach(fieldUser => {
        if (this.doesNotBelongToParentCompany(fieldUser.user)) {
          buildOwnersUsers.push(fieldUser.user);
        } else {
          isParentFieldUser = true;
          nonBuildOwnerUsers.push(fieldUser.user);
        }
        reviewerFilter.push(fieldUser.user);
        approverFilter.push(fieldUser.user);
        notifyFilter.push(fieldUser.user);
      });

      let isParentUser = false;
      reviewerUsers.forEach(reviewer => {
        if (!this.doesNotBelongToParentCompany(reviewer)) {
          isParentUser = true;
        }
        field_userFilter.push(reviewer);
        approverFilter.push(reviewer);
        notifyFilter.push(reviewer);
      });

      approverUsers.filter(approver => {
        field_userFilter.push(approver);
        reviewerFilter.push(approver);
        notifyFilter.push(approver);
        return true;
      });

      const users = project.users.filter(user => {
        return this.isBuildOwner && user.companies[0].id != this.props.project.company_id;
      });

      if (!isParentFieldUser) {
        assignedToSection = <div className="half-field input-enabled">
          <div className="label">{field_userFilter && field_userFilter.length > 1 ? 'Assigned To' : this.textMap.assignedTo}</div>
          <div className="field">
            <SelectUserComboBox 
              key="field-user" 
              noFocus={true}
              width={200} 
              hasBorder={false} 
              multiSelect={true} 
              height={32}
              handleMultipleSelection={this.handleFieldUserSelection} 
              users={users} 
              filterUsers={field_userFilter} 
              selectedUsers={assignedToUsers}
              pointerPosition={null}
              menuHeight={200}
              menuBelow={true}
            />
          </div>
        </div>;
      } else if ((isParentFieldUser && buildOwnersUsers.length) || this.buildOwnersUsersHadLength) {
        //do the new HTML with the select user combobox
        //show the component for the rest of the session if it met the original requirements
        this.buildOwnersUsersHadLength = true;
        const assignedImages = this.createMemberArrayWithName(nonBuildOwnerUsers, 'field_user');
        assignedToSection = (
            <div className="half-field input-enabled">
              <div className="label">{field_userFilter && field_userFilter.length > 1 ? 'Assigned To' : this.textMap.assignedTo}</div>
              <div className="member-array-stacked" id="with-parent-user">
                {assignedImages}
              </div>
              <div className="field">
                <SelectUserComboBox 
                  key="field-user" 
                width={200} 
                noFocus={true}

                  hasBorder={false} 
                  multiSelect={true} 
                  height={32}
                  handleMultipleSelection={this.handleFieldUserSelection} 
                  users={users}  
                  selectedUsers={buildOwnersUsers}
                  pointerPosition={null}
                  menuHeight={200}
                  menuBelow={true}
                />
              </div>
            </div>
        );
      }

      if (!isParentUser) {
        reviewerSection = <div className={'half-field input-enabled ' + (reviewerAvatars ? 'with-avatars' : '')}>
          <div className="label">{this.textMap.reviewer}</div>
          <div className={'field ' + (reviewerAvatars ? 'with-avatars' : '')}>
            <SelectUserComboBox 
              key="reviewer-user" 
              width={200} 
              hasBorder={false} 
              multiSelect={false} 
              currentSelectedUser={reviewerUsers.length > 0 ? reviewerUsers[0] : null} 
              menuBelow={true}
              handleSelection={this.handleReviewerSelection}
              users={users} 
              filterUsers={reviewerFilter} 
              noFocus={true}
            />
          </div>
        </div>;

      }

    }    

    return (
      // Replace with the appropriate HTML
      <div id={this.props.id} className="build-owner-task-edit">
        <div className="settings-header">
          <div className="caption">{this.textMap.taskSettings}</div>
          <div className="status">{taskStatus}</div>
        </div>
        <hr className="separator" />

        <div className="project-info">
          <div className="info-detail">
            <div className="caption">{this.textMap.dueDate}</div>
            <div className="value">{dueDate ? dueDate : 'Not Specified'}</div>
          </div>
          <div className="info-detail">
            <div className="caption">{this.textMap.time}</div>
            <div className="value">{dueTime ? dueTime : 'Not Specified'}</div>
          </div>
        </div>
        <div className="project-info">
          {assignedToSection}  
          <div className="info-detail">
            <div className="caption">{this.textMap.notifiers}</div>
            {notifiedAvatars}
          </div>
        </div>
        <div className="project-info">
          {reviewerSection}  
          <div className="info-detail">
            <div className="caption">{this.textMap.approver}</div>
            {approverAvatars}
          </div>          
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
  };
};

export default connect(mapStateToProps)(BuildOwnerTaskEdit);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/BuildOwnerTaskEdit/index.js